import Vue from 'vue';
import Vuex from 'vuex';
import common from './modules/common';
import dialog from './modules/dialog';
import event from './modules/event';
import settings from './modules/settings';
import video from './modules/video';
import auth from './modules/auth';
import home from './modules/home';
import log from './modules/log';
import help from './modules/help';
import record from './modules/record';
import multiCam from './modules/multiCam';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    common,
    event,
    dialog,
    settings,
    video,
    auth,
    home,
    log,
    help,
    record,
    multiCam,
  },
});
